var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CardedTable',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.ward",fn:function(ref){
var item = ref.item;
return [_c('v-icon',[_vm._v(_vm._s(item.ward.name))])]}},{key:"item.city",fn:function(ref){
var item = ref.item;
return [_c('v-icon',[_vm._v(_vm._s(item.city.name))])]}},{key:"item.district",fn:function(ref){
var item = ref.item;
return [_c('v-icon',[_vm._v(_vm._s(item.district.name))])]}},{key:"item.country",fn:function(ref){
var item = ref.item;
return [_c('v-icon',[_vm._v(_vm._s(item.country.name))])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"x-small":"","rounded":"","text":"","color":"success"},on:{"click":function($event){return _vm.on_view_item(item)}}},[_c('v-icon',[_vm._v("mdi-eye")])],1)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }